<template>
  <gw-listing :title="$t('Visao')" :entityDtoRestResource="visaoRestResource"
  :presentation="presentation">

    <gw-column field="status"/>
    <gw-column field="nome"/>

    <template slot="filterBand">
      <gw-possible-value-filter-item :display-text="$t('Visao.ui.filtroStatus')"
        property-name="status" :possibleValues="statusPossibleValues"/>
      <a7-classificacao-indicador-filter-item :display-text="$t('Visao.ui.filtroDepartamento')"
        property-name="classificacaoDepartamento"
        :tipo="classificacaoIndicadorConstants.TIPO_DEPARTAMENTO"/>

      <gw-text-filter-item :display-text="$t('Visao.ui.filtroNome')" property-name="nome"/>
    </template>

    <template slot="editor">
      <gw-grouping-pane :title="$t('Global.ui.detalhes')">
        <gw-grid-container>
          <div class="gw-row">
            <gw-editor-field property="nome" class="gw-col-9"/>
            <gw-editor-field property="status" class="gw-col-3"/>
          </div>
          <div class="gw-row">
            <gw-editor-field property="classificacaoDepartamento" class="gw-col-9">
              <a7-classificacao-indicador-entity-chooser
                slot-scope="{ entity, properties }"
                v-model="entity.classificacaoDepartamento"
                v-bind="properties"
                :tipo="classificacaoIndicadorConstants.TIPO_DEPARTAMENTO" folha/>
            </gw-editor-field>
            <gw-editor-field property="tabela" class="gw-col-3"/>
          </div>
          <div class="gw-row">
            <gw-editor-field property="metaDados" class="gw-col-12" :minHeight="250" />
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
    </template>
  </gw-listing>
</template>

<script>
import {
  GwListing,
  GwColumn,
  GwTextFilterItem,
  GwPossibleValueFilterItem,
  GwGroupingPane,
  GwGridContainer,
  GwEditorField,
  GwAction,
  DefaultExceptionHandler,
  FilterUtilities
} from 'guaxinim-web';
import VisaoRestResource from './VisaoRestResource';
import A7ClassificacaoIndicadorFilterItem
  from  '../classificacaoIndicador/A7ClassificacaoIndicadorFilterItem';
import A7ClassificacaoIndicadorEntityChooser
  from  '../classificacaoIndicador/A7ClassificacaoIndicadorEntityChooser';
import ClassificacaoIndicadorConstants
  from  '../classificacaoIndicador/ClassificacaoIndicadorConstants';

export default {
  name: 'a7-visao-listing',
  components: {
    GwListing,
    GwColumn,
    GwTextFilterItem,
    GwPossibleValueFilterItem,
    GwGroupingPane,
    GwGridContainer,
    GwEditorField,
    GwAction,
    A7ClassificacaoIndicadorEntityChooser,
    A7ClassificacaoIndicadorFilterItem
  },
  data() {
    return {
      visaoRestResource: VisaoRestResource,
      presentation: null,
      classificacaoIndicadorConstants: ClassificacaoIndicadorConstants
    }
  },
  computed: {
    statusPossibleValues() {
      if (!this.presentation) return [];
      return this.presentation.properties.status.possibleValues;
    }
  },
  methods: {
  },
  created() {
    this.visaoRestResource.getDtoPresentation()
      .then(presentation => this.presentation = presentation)
      .catch(err => this.$gw.defaultExceptionHandler.handleUnknowException(err, this))
  }
}
</script>

<style>
</style>
